<template>
    <div class="card" :class="{ isclosed: item.isclosed === true }">
        <div class="card-checkbox"><CustomCheckbox :id="item.id" v-model="checked" /></div>
        <div class="card-content">
            <span class="card-title">{{ item.name }}</span>
            <div class="card-actions">
                <font-awesome-icon
                    title="Cloner"
                    icon="clone"
                    class="card-actions--icon duplicate"
                    @click="handleDuplicate(item.id)"
                />
                <font-awesome-icon
                    title="Modifier"
                    icon="pencil-alt"
                    class="card-actions--icon"
                    v-if="item.isclosed !== true"
                    @click="handleEdit(item.id)"
                />
                <font-awesome-icon
                    title="Rattachement automatique"
                    icon="magic"
                    class="card-actions--icon automatic"
                    v-if="item.isclosed !== true && item.isinverse !== true"
                    @click="handleAutomaticRattachmentConfirm(item.id)"
                />
                <font-awesome-icon
                    title="Clore"
                    icon="window-close"
                    class="card-actions--icon close"
                    v-if="item.isclosed !== true"
                    @click="handleCloseConfirm(item.id)"
                />
                <font-awesome-icon
                    title="Supprimer"
                    icon="trash-alt"
                    class="card-actions--icon alert"
                    @click="handleConfirm(item.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CustomCheckbox from '@/components/Checkbox';

export default {
    props: {
        item: { type: Object, required: true },
        selected: [Array],
        handleDuplicate: { type: Function },
        handleEdit: { type: Function },
        handleConfirm: { type: Function },
        handleCloseConfirm: { type: Function },
        handleAutomaticRattachmentConfirm: { type: Function },
    },
    data() {
        return {
            checked: this._getCheck(this.selected),
        };
    },
    watch: {
        selected(val) {
            this.checked = this._getCheck(val);
        },
        checked(val) {
            this.$emit('selected', { id: this.item.id, checked: val });
        },
    },
    methods: {
        _getCheck(val) {
            return val && val.some((s) => s === this.item.id);
        },
    },
    components: {
        CustomCheckbox,
    },
};
</script>

<style lang="scss">
.card.isclosed {
    background-color: #ccc;
}
.cards .card.isclosed .card-content .card-title {
    color: #666;
}
</style>
